import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { KEY_VALUES } from '../utils';
import mergeRefs from '../utils/mergeRefs';
import ClassNames from 'classnames';
import { useControlled } from '../utils';
import { Tooltip } from '../tooltip';
;
var Navigation = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    _ref$solid = _ref.solid,
    solid = _ref$solid === void 0 ? false : _ref$solid,
    _ref$selectedIndex = _ref.selectedIndex,
    selectedIndex = _ref$selectedIndex === void 0 ? 0 : _ref$selectedIndex,
    selectedSubIndex = _ref.selectedSubIndex,
    onClickCollapseEvent = _ref.onClickCollapseEvent,
    onClickItem = _ref.onClickItem,
    onClickSubItem = _ref.onClickSubItem,
    onClickLogo = _ref.onClickLogo,
    _ref$hasLogo = _ref.hasLogo,
    hasLogo = _ref$hasLogo === void 0 ? true : _ref$hasLogo,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'button' : _ref$role,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 280 : _ref$width,
    navList = _ref.navList,
    titleTemplate = _ref.titleTemplate,
    userTemplate = _ref.userTemplate,
    className = _ref.className,
    style = _ref.style,
    collapsedProp = _ref.collapsed,
    _ref$hasHeader = _ref.hasHeader,
    hasHeader = _ref$hasHeader === void 0 ? true : _ref$hasHeader,
    _ref$hasFooter = _ref.hasFooter,
    hasFooter = _ref$hasFooter === void 0 ? true : _ref$hasFooter,
    defaultCollapsed = _ref.defaultCollapsed,
    _ref$toggleFromSuffix = _ref.toggleFromSuffixIconOnly,
    toggleFromSuffixIconOnly = _ref$toggleFromSuffix === void 0 ? false : _ref$toggleFromSuffix,
    _ref$showTooltip = _ref.showTooltip,
    showTooltip = _ref$showTooltip === void 0 ? false : _ref$showTooltip,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'right' : _ref$direction,
    _ref$distance = _ref.distance,
    distance = _ref$distance === void 0 ? 8 : _ref$distance,
    _ref$collapseBtnText = _ref.collapseBtnText,
    collapseBtnText = _ref$collapseBtnText === void 0 ? 'collapse' : _ref$collapseBtnText;
  var _useControlled = useControlled(collapsedProp, defaultCollapsed || false),
    collapsed = _useControlled[0],
    setCollapsed = _useControlled[1],
    isControlled = _useControlled[2];
  var _React$useState = React.useState(navList),
    list = _React$useState[0],
    setList = _React$useState[1];
  var navRef = React.useRef(null);
  var footerRef = React.useRef(null);
  var _React$useState2 = React.useState(selectedIndex),
    parentIndex = _React$useState2[0],
    setParentIndex = _React$useState2[1];
  var _React$useState3 = React.useState(selectedSubIndex),
    subIndex = _React$useState3[0],
    setSelectedSubIndex = _React$useState3[1];
  var firstRef = React.useRef(true);
  var _React$useState4 = React.useState(false),
    parentHighlightStatus = _React$useState4[0],
    setParentHighlightStatus = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    subHighlightStatus = _React$useState5[0],
    setSubHighlightStatus = _React$useState5[1];
  var classes = ClassNames("ap-navigation-wrapper", {
    "collapse-nav": collapsed,
    "solid-nav": solid
  }, className);
  var updateHighlight = function updateHighlight(selectedIndex, selectedSubIndex) {
    if (toggleFromSuffixIconOnly && (selectedIndex || selectedIndex === 0) && (selectedSubIndex || selectedSubIndex === 0)) {
      setParentHighlightStatus(false);
      setSubHighlightStatus(true);
    } else if (toggleFromSuffixIconOnly && (selectedIndex || selectedIndex === 0)) {
      setParentHighlightStatus(true);
      setSubHighlightStatus(false);
    } else if (toggleFromSuffixIconOnly) {
      setParentHighlightStatus(true);
      setSubHighlightStatus(true);
    }
  };
  var updateOpenedItem = function updateOpenedItem() {
    list && setList(list.map(function (item, index) {
      return index === selectedIndex ? _extends({}, item, {
        opened: true
      }) : item;
    }));
  };
  React.useImperativeHandle(ref, function () {
    return {
      updateOpenedItem: updateOpenedItem
    };
  });
  React.useEffect(function () {
    firstRef.current = false;
    updateHighlight(selectedIndex, selectedSubIndex);
  }, []);
  React.useEffect(function () {
    setSelectedSubIndex(selectedSubIndex);
    updateHighlight(selectedIndex, selectedSubIndex);
    updateOpenedItem();
  }, [selectedSubIndex]);
  React.useEffect(function () {
    var _list$find;
    setParentIndex(selectedIndex);
    var childrenValue = list === null || list === void 0 ? void 0 : (_list$find = list.find(function (item, index) {
      return index === selectedIndex;
    })) === null || _list$find === void 0 ? void 0 : _list$find.children;
    if (!childrenValue || childrenValue.length === 0) {
      selectedSubIndex = undefined;
    }
    setSelectedSubIndex(selectedSubIndex);
    updateHighlight(selectedIndex, selectedSubIndex);
    updateOpenedItem();
  }, [selectedIndex]);
  React.useEffect(function () {
    setList(navList);
  }, [navList]);
  var getParentHighlightStatus = function getParentHighlightStatus() {
    if (toggleFromSuffixIconOnly) {
      setParentHighlightStatus(true);
      setSubHighlightStatus(false);
    }
  };
  var getSubHighlightStatus = function getSubHighlightStatus(event) {
    event.stopPropagation();
    event.preventDefault();
    if (toggleFromSuffixIconOnly) {
      setSubHighlightStatus(true);
      setParentHighlightStatus(false);
    }
  };
  var _onClick = function onClick(event, item, index, indexParent, isSub, callClickItem) {
    if (isSub === void 0) {
      isSub = false;
    }
    if (callClickItem === void 0) {
      callClickItem = true;
    }
    event.stopPropagation();
    if (isSub) {
      setParentIndex(indexParent);
      // callClickItem && onClickItem?.(event, item, index, true);
      setSelectedSubIndex(index);
      onClickSubItem === null || onClickSubItem === void 0 ? void 0 : onClickSubItem(event, item, index, indexParent);
      getSubHighlightStatus(event);
    } else {
      if (toggleFromSuffixIconOnly) {
        setParentIndex(indexParent);
      } else {
        if (!item.children) {
          callClickItem && setSelectedSubIndex(undefined);
          setParentIndex(indexParent);
        }
      }
      callClickItem && (onClickItem === null || onClickItem === void 0 ? void 0 : onClickItem(event, item, index, !item.children));
      getParentHighlightStatus();
      // !item.children && callClickItem && setSelectedSubIndex(undefined);
      // !item.children && setParentIndex(indexParent);
    }

    return;
  };
  var onClickCollapse = function onClickCollapse(event) {
    var newValue = !collapsed;
    setCollapsed(newValue);
    onClickCollapseEvent === null || onClickCollapseEvent === void 0 ? void 0 : onClickCollapseEvent(newValue, event);
  };
  var keyupEvent = function keyupEvent(event, item, index, indexParent, isSub, isBySuffixIcon) {
    if (isSub === void 0) {
      isSub = false;
    }
    if (isBySuffixIcon === void 0) {
      isBySuffixIcon = false;
    }
    event.stopPropagation();
    if (event.key !== KEY_VALUES.ENTER) {
      return;
    }
    item.children ? navItemClick(event, item, indexParent, isBySuffixIcon) : _onClick && _onClick(event, item, index, indexParent, isSub);
  };
  var onKeyupCollapse = function onKeyupCollapse(event) {
    var key = event.key;
    if (KEY_VALUES.ENTER === key) {
      onClickCollapse(event);
    }
  };
  var navItemClick = function navItemClick(event, navItem, index, isBySuffixIcon) {
    if (isBySuffixIcon === void 0) {
      isBySuffixIcon = false;
    }
    navItem.children && event.stopPropagation();
    if (_onClick && !(toggleFromSuffixIconOnly && isBySuffixIcon)) {
      _onClick(event, navItem, index, index, false);
    }
    if (navItem.children && navItem.children.length > 0 && (!toggleFromSuffixIconOnly || isBySuffixIcon)) navItem.opened = !navItem.opened;
    list && setList(list.map(function (item) {
      return item.name === navItem.name ? _extends({}, item, {
        opened: navItem.opened
      }) : item;
    }));
    if (toggleFromSuffixIconOnly && !isBySuffixIcon && navItem.children) {
      selectedSubIndex = undefined;
      setSelectedSubIndex(undefined);
      onClickSubItem === null || onClickSubItem === void 0 ? void 0 : onClickSubItem(event, undefined, undefined, index);
    }
    ;
  };
  return /*#__PURE__*/React.createElement("nav", {
    id: id,
    className: classes,
    style: _extends({}, style, {
      width: collapsed ? 72 : width
    }),
    ref: mergeRefs(ref, navRef)
  }, hasHeader && /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-heading"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-title-wrapper"
  }, hasLogo && /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-logo",
    onClick: onClickLogo
  }), /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-title"
  }, titleTemplate && /*#__PURE__*/React.createElement("div", {
    className: "ap-header-title"
  }, titleTemplate()))), /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-avatar-content"
  }, userTemplate === null || userTemplate === void 0 ? void 0 : userTemplate())), /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-content"
  }, list && list.map(function (navItem, index) {
    if (firstRef.current && index === parentIndex && selectedSubIndex !== undefined && navItem.children && navItem.children.length > 0) {
      navItem.opened = true;
    }
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: ClassNames(navItem.itemClassName)
    }, showTooltip && collapsed && /*#__PURE__*/React.createElement(Tooltip, {
      trigger: "hover",
      hideTooltipOnBlur: true,
      content: navItem.name,
      position: direction,
      distance: distance,
      target: ".ap-nav-item.nav-with-child.item-" + index
    }), /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "ap-nav-item nav-with-child " + (navItem.opened && !collapsed ? 'nav-item-expanded' : '') + " item-" + index,
      tabIndex: 0,
      role: role,
      "aria-label": navItem.name,
      "aria-current": index === parentIndex ? 'page' : undefined,
      onClick: function onClick(event) {
        return _onClick(event, navItem, index, index);
      },
      onKeyUp: function onKeyUp(event) {
        return keyupEvent(event, navItem, index, index);
      }
    }, /*#__PURE__*/React.createElement("a", {
      className: "ap-navigation-item\n                                        " + (!toggleFromSuffixIconOnly && parentIndex === index && (!navItem.children && subIndex === undefined || !navItem.opened && navItem.children && subIndex !== undefined || collapsed) ? 'selected' : '') + "\n                                        " + (parentIndex === index && parentHighlightStatus ? ' active' : ''),
      onClick: function onClick(event) {
        return navItem.children ? navItemClick(event, navItem, index) : {};
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "prefix-content"
    }, (navItem.prefixIcon || navItem.prefixIconClass) && /*#__PURE__*/React.createElement("span", {
      className: ClassNames("prefixIcon", navItem.prefixIconClass ? navItem.prefixIconClass : "Appkit4-icon icon-" + navItem.prefixIcon + "-outline"),
      "aria-label": navItem.name,
      "aria-hidden": !collapsed
    })), !collapsed && /*#__PURE__*/React.createElement("span", {
      className: "itemContent"
    }, navItem.name), (navItem.suffixIcon || navItem.suffixIconClass) && !collapsed && /*#__PURE__*/React.createElement("span", {
      "aria-label": toggleFromSuffixIconOnly ? 'toggle button' : undefined,
      className: ClassNames("suffixIcon", navItem.suffixIconClass ? navItem.suffixIconClass : "Appkit4-icon icon-" + navItem.suffixIcon + "-outline", "" + (navItem.opened ? 'rotate' : '')),
      "aria-hidden": toggleFromSuffixIconOnly ? false : true,
      tabIndex: toggleFromSuffixIconOnly ? 0 : -1,
      onClick: function onClick(event) {
        return toggleFromSuffixIconOnly && navItemClick(event, navItem, index, true);
      },
      onKeyUp: function onKeyUp(event) {
        return toggleFromSuffixIconOnly && keyupEvent(event, navItem, index, index, false, true);
      }
    })), navItem.children && /*#__PURE__*/React.createElement("div", {
      className: "nav-item-child"
    }, navItem.children.map(function (item, indexChildren) {
      return /*#__PURE__*/React.createElement("div", {
        className: ClassNames("nav-item", item.itemClassName),
        key: item.name,
        onClick: function onClick(event) {
          return _onClick(event, item, indexChildren, index, true);
        },
        onKeyUp: function onKeyUp(event) {
          return keyupEvent(event, item, indexChildren, index, true);
        },
        role: "link"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ap-navigation-item \n                                                                " + (!toggleFromSuffixIconOnly && parentIndex === index && subIndex === indexChildren ? 'selected' : '') + "\n                                                                " + (parentIndex === index && subIndex === indexChildren && subHighlightStatus ? ' active' : ''),
        tabIndex: navItem.opened ? 0 : -1
      }, /*#__PURE__*/React.createElement("div", {
        className: "prefix-content"
      }, (item.prefixIcon || item.prefixIconClass) && /*#__PURE__*/React.createElement("span", {
        className: ClassNames("prefixIcon", "has-icon", item.prefixIconClass ? item.prefixIconClass : "Appkit4-icon icon-" + item.prefixIcon + "-outline"),
        "aria-label": item.name,
        "aria-hidden": !collapsed
      })), /*#__PURE__*/React.createElement("span", {
        className: "itemContent"
      }, item.name), (item.suffixIcon || item.suffixIconClass) && /*#__PURE__*/React.createElement("span", {
        className: ClassNames("suffixIcon", item.suffixIconClass ? item.suffixIconClass : "Appkit4-icon icon-" + item.suffixIcon + "-outline", "" + (item.opened ? 'rotate' : '')),
        "aria-hidden": true
      })));
    })))), navItem.divider);
  })), /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-footer",
    ref: footerRef,
    style: {
      width: collapsed ? 72 : width
    }
  }, hasFooter && /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-item collapsed-item",
    role: "button",
    "aria-expanded": collapsed,
    "aria-label": "navigation operation",
    tabIndex: 0,
    onClick: onClickCollapse,
    onKeyUp: onKeyupCollapse
  }, /*#__PURE__*/React.createElement("div", {
    className: "prefix-content"
  }, !collapsed ? /*#__PURE__*/React.createElement("span", {
    className: "prefixIcon Appkit4-icon icon-enter-left-outline"
  }) : /*#__PURE__*/React.createElement("span", {
    className: "prefixIcon Appkit4-icon icon-enter-right-outline"
  })), /*#__PURE__*/React.createElement("span", {
    className: "itemContent"
  }, collapseBtnText))));
});
Navigation.displayName = 'Navigation';
export default Navigation;